
import $ from 'jquery';

import {validEmail,isUrlValid,isEmptyInput} from './../general/Validation.js';


class SuggestPriceForm {

    constructor( form ) {

        this.$form = $( form );
        this.$form.on( 'submit', (evt) => this.onSubmit(evt) );
    }

    addError = ( selector ) => {

        const $selector = $( selector );
        $selector.parent().parent().addClass('row_has_message').removeAttr('data-notification');
        $selector.parent().parent().addClass('has_error').removeAttr('data-notification');
        return $selector;
    };

    removeError = ( selector ) => {

        const $selector = $( selector );
        $selector.parent().parent().removeClass('row_has_message').attr('data-notification', 'error');
        $selector.parent().parent().removeClass('has_error').attr('data-notification', 'error');
        return $selector;
    };

    validateTextInput = ( selector ) => {
        if ( isEmptyInput( selector ) ) {
            this.addError( selector );
            return false;
        } else {
            this.removeError( selector )
            return true;
        }
    };

    validateEmailInput = ( selector ) => {
        const $email = $( selector );
        if ( isEmptyInput( $email ) || ! validEmail( $email.val() ) ) {
            this.addError( $email );
            return false;
        } else {
            this.removeError( $email )
            return true;
        }
    };

    validateUrlInput = ( selector ) => {
        const $url = $( selector );
        if ( isEmptyInput( $url ) || ! isUrlValid( $url.val() ) ) {
            this.addError( $url );
            return false;
        } else {
            this.removeError( $url )
            return true;
        }
    };

    onSubmit = ( evt ) => {
        evt.preventDefault();

        let valid = true;

        const $email = $('#popup_suggest_email');
        const $url   = $('#popup_suggest_link');
        const $fname = $('#popup_suggest_firstname');
        const $lname = $('#popup_suggest_lastname');
        const $price = $('#popup_suggest_price');
        const $emailconfirm = $('#popup_suggest_email_confirm');

        // $emailconfirm should remain empty.
        if ( ! isEmptyInput( $emailconfirm ) ) {
            valid = false;
        }

        // Validate Text Inputs.
        if ( ! this.validateTextInput( $fname ) ){
            valid = false;
        }
        if ( ! this.validateTextInput( $lname ) ){
            valid = false;
        }
        if ( ! this.validateTextInput( $price ) ){
            valid = false;
        }

        // Validate E-Mail.
        if ( ! this.validateEmailInput( $email ) ) {
            valid = false;
        }

        // Validate URL.
        if ( ! this.validateUrlInput( $url ) ) {
            valid = false;
        }

        if ( valid ) {
            const url  = "/index.php?cl=searchservice_oxwarticledetails&fnc=sendSuggestPriceMail";
            const data = this.$form.serialize();

            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                complete: function( response ) {
                    if ( response ) {
                        $('#suggestPriceMailSend > p').html('Ihre Preisanfrage wurde erfolgreich übermittelt. Unser Kundenservice setzt sich so rasch wie möglich mit Ihnen in Verbindung.');
                    } else {
                        $('#suggestPriceMailSend > p').html('Ihre Preisanfrage wurde nicht übermittelt. Versuchen Sie es später erneut.');
                    }

                    EN_KO.functions.close_popup( '#popup_haggle' );
                    $('#suggestPriceMailSend').show();
                }
            });
        }
        return false;
    }
}


/*
** Move from productmain.tpl
*/
$(document).ready(function() {

    if ( $( '#suggestPriceForm' ).length > 0 ) {

        $('#billigerGesehen > a').click(function(e){
            $('#popup_suggest_email_confirm').parent().parent().parent().hide();
        });

        const PriceFormInstance = new SuggestPriceForm( '#suggestPriceForm' );
        $( '#suggestPriceForm' ).data( 'SuggestPriceForm', PriceFormInstance );
    }
});
